<template>
  <div>
    <h1>Hey</h1>
    <button @click="test">Click</button>
    <button @click="firebasee">Click Fiah</button>
  </div>
</template>

<script>
import { degrees, PDFDocument, StandardFonts, rgb } from "pdf-lib";
import b64toArray from "base64-arraybuffer";
import download from "downloadjs";
import pdfString from "raw-loader!../assets/cert.txt";
import firebase from "firebase"
export default {
  data() {
    return {
      pdfBytes: "",
    };
  },
  methods: {
    getX(start, end, fieldWidth, textWidth) {
      if (textWidth >= fieldWidth) {
        return start;
      } else {
        return start + (end - textWidth) / 2;
      }
    },
    async test() {
      //console.log(pdf);
      var pdf = pdfString;
      var existingPdfBytes = b64toArray.decode(pdf);
      //console.log(xx);
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      console.log(helveticaFont);
      // Get the first page of the document
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];

      // Get the width and height of the first page
      const { width, height } = firstPage.getSize();
      console.log(width / 3 - 15);
      var Nstart = width / 3 - 15;
      var Nend = Nstart * 1.5;
      var Nwidth = Nend;

      var Pstart = width / 8 - 15;
      var Pend = Pstart * 4.85 ;
      var Pwidth = Pend;
      console.log(
        Pstart,
        Pend,
        Pwidth,
        helveticaFont.widthOfTextAtSize(
          "Vignesh Chandrashekar Govindaraj AAAAAA",
          22
        )
      );
      // Draw a string of text diagonally across the first page
      firstPage.drawText("Vignesh Chandrashekar ", {
        x: this.getX(
          Nstart,
          Nend,
          Nwidth,
          helveticaFont.widthOfTextAtSize("Vignesh Chandrashekar", 22)
        ),
        y: height / 2 + 3,
        size: 22,
        font: helveticaFont,
      });
      firstPage.drawText("Bangalore", {
        x:
         this.getX(Pstart,Pend,Pwidth,helveticaFont.widthOfTextAtSize("Bangalore",22)),
        y: height / 2 - 33,
        size: 22,
        font: helveticaFont,
      });
      firstPage.drawText(
        new Date().toJSON().slice(0, 10).split("-").reverse().join("/"),
        {
          x: width / 3.5 - 5,
          y: height / 3.5 + 5,
          size: 18,
          font: helveticaFont,
        }
      );
      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();
      download(pdfBytes, "certificate.pdf", "application/pdf");
    },
    async firebasee(){
      var user = null;
        var UserDetails = await firebase
        .database()
        .ref()
        .child("UserDetails")
        .on("value",(data)=>{
          console.log(data.val())
        })
    }
  },
  created() {
    // this.test();
    //console.log(pdfString)
  },
};
</script>

<style>
</style>